import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import whatsAppIcon from '../assets/icons/whatsapp.svg'
import ShareDialog from './ShareDialog'
import { Link } from 'react-router-dom'

const CeremonyCard = ({
  imgSrc,
  title,
  description,
  label,
  shareLink = '',
  detailLink = '',
  className = '',
  birthDate
}) => {

  const { i18n } = useTranslation();

  const formatBirthDate = (bd) => {
    if (!bd) return bd;

    const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthsMr = ['जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल', 'मे', 'जून', 'जुलै', 'ऑगस्ट', 'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'];

    let day, monthIndex;

    // Try ISO format (YYYY-MM-DD)
    if (bd.includes('-') && bd.length >= 10) {
      const parts = bd.split('-');
      if (parts.length >= 3) {
        day = parseInt(parts[2], 10);
        monthIndex = parseInt(parts[1], 10) - 1;
      }
    }
    // Try DD/MM or DD/MM/YYYY format
    else if (bd.includes('/')) {
      const parts = bd.split('/').map(p => p.trim());
      if (parts.length >= 2) {
        day = parseInt(parts[0], 10);
        monthIndex = parseInt(parts[1], 10) - 1;
      }
    }

    // Validate and format
    if (isNaN(day) || isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
      return bd;
    }

    const monthName = i18n.language === 'mr' ? monthsMr[monthIndex] : monthsEn[monthIndex];
    return `${day} ${monthName}`;
  }

  const [openShare, setOpenShare] = useState(false)

  const handleShareOpen = () => {
    setOpenShare(true)
  }

  const handleShareClose = () => setOpenShare(false)

  return (
    <div
      className={`border rounded-md bg-white border-[#DDDDDD] overflow-hidden flex flex-col ${className}`}
    >
      {/* Image */}
      {imgSrc && (
        <Link to={detailLink} className="block">
          <img
            src={imgSrc}
            alt={title}
            className="w-full h-48 md:h-[271px] object-cover rounded-t-md"
          />
        </Link>
      )}

      {/* Content */}
      <div className="p-4 flex flex-col flex-grow">
        <h2 className="text-[20px] font-semibold mb-2 leading-tight m-0">
          <Link to={detailLink} className="hover:underline">{title}</Link>
        </h2>

        <p className="text-[14px] text-[#212121] leading-relaxed m-0 flex-grow">
          {description}
        </p>

        {/* Birthday Date */}
        {birthDate && (
          <div className="mt-3 pt-2 border-t border-gray-100">
            <p className="text-[13px] font-medium text-[#666666] m-0">
              🎂 {formatBirthDate(birthDate)}
            </p>
          </div>
        )}

        {/* WhatsApp Button */}
        <button
          onClick={handleShareOpen}
          className="mt-4 w-full flex items-center justify-center gap-2 p-2 bg-[var(--color-primary)] hover:bg-[var(--color-primary-dark)] text-white rounded-md font-medium"
        >
          <img loading="lazy" src={whatsAppIcon} alt="share" className="w-5 h-5" />
          <span className='text-sm'>{label}</span>
        </button>

        <ShareDialog
          open={openShare}
          onClose={handleShareClose}
          title={title}
          description={description}
          url={detailLink || shareLink}
          image={imgSrc}
        />
      </div>
    </div>
  )
}

export default CeremonyCard
